export default {
  placement: 'COMPARE-PLANS',
  tagMaropost: 'Compare Plans'
}
